/**
 * Les trois primitives d'identité et de date, à UN seul endroit.
 *
 * Elles vivaient en `const` privées dans `relances.ts`. Dès qu'un second module
 * du domaine finance en a eu besoin, le choix était : les redéfinir (donc avoir
 * deux règles qui peuvent diverger) ou créer un import circulaire. Ni l'un ni
 * l'autre — elles sortent ici.
 */
import { z } from "zod";

export const IsoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "date ISO attendue");

export const Uuid = z.string().uuid();

/**
 * Identifiant d'un objet MÉTIER : travail, facture, praticien.
 *
 * PAS un UUID depuis la bascule du 2026-08-11 : ces objets viennent désormais
 * de Vevidental, qui les numérote en entiers (« 41094416 »), et non plus de
 * Twenty qui les numérotait en UUID. Les DEUX formes coexistent en base — les
 * cartes antérieures que le remap n'a pas pu transposer portent encore un
 * UUID, et les créations manuelles aussi.
 *
 * INCIDENT FONDATEUR : ce champ est resté `Uuid` après la bascule. Le serveur
 * envoyait « 443420 », le contrat exigeait un UUID, et l'écran « À relancer »
 * répondait « contrat DTO non respecté » — l'application était INUTILISABLE en
 * production pendant ~3 h. Personne ne l'a vu parce qu'aucun test ne validait
 * une réponse de file complète contre ce schéma.
 *
 * RÉCIDIVE, le 2026-08-12 : `FinanceSurveille.factureId` était resté en `Uuid`,
 * douze lignes sous la correction. Le test de contrat ne pouvait pas le voir —
 * il envoyait une liste VIDE, et une liste vide valide n'importe quel schéma.
 *
 * `cabinetId` NE CHANGE PAS : les fiches cabinet vivent dans Twenty, et
 * `correspondance_cabinet` fait le pont. C'est volontaire, pas un oubli.
 */
export const IdMetier = z.string().min(1);
